import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { useFormikContext } from 'formik';

import PhoneNumber from 'components/user/Profile/MyInfo/PhoneNumber';
import CopyQuestionAnswer from 'components/questions/CopyQuestionAnswer';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useQuestion } from 'components/events/Timeline/TimelineQuestionsBlock/TimelineQuestionsContext';

import useCommonStyles from '../../common/style';
import useStyles from './style';

const PhoneAnswer: FC = () => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();

  const { setFieldValue } = useFormikContext<UpdateQuestionForm>();

  const { question, canAnswer } = useQuestion();

  const phoneNumber = useMemo(() => question.answer?.phoneNumber, [question.answer?.phoneNumber]);
  const number = useMemo(() => phoneNumber?.phoneNumber, [phoneNumber?.phoneNumber]);
  const code = useMemo(() => phoneNumber?.phoneCode, [phoneNumber?.phoneCode]);
  const value = useMemo(() => (!!code && !!number ? `+${code}${number}` : ''), [code, number]);

  return (
    <div className={classNames('phoneAnswer', commonClasses.locationAnswer)}>
      <Icon icon={IconmoonFont['phone-16']} />
      <PhoneNumber
        onChange={(phoneNumber, { dialCode, countryCode }) => {
          setFieldValue(
            'answer.phoneNumber.phoneNumber',
            phoneNumber.replace(new RegExp(dialCode, 'i'), '')
          );
          setFieldValue('answer.phoneNumber.phoneCode', !!phoneNumber ? dialCode : null);
          setFieldValue('answer.phoneNumber.country', countryCode);
        }}
        value={value}
        disabled={!canAnswer}
        containerClass={classes.phonePreviewInput}
        disableBaseClasses
        key={`phone-answer-${question._id}`}
      />
      {!!number ? <CopyQuestionAnswer value={value} /> : null}
    </div>
  );
};
export default PhoneAnswer;
